module.exports = __webpack_public_path__ + "static/media/irm-shred-bin-white.1f44dae3.svg";